import { GALLERY_MAP } from 'consts/galleryList';
import { useHistory } from 'react-router-dom';

export const useGalleryHandle = () => {
  const history = useHistory();
  return (label, preserveState = false) => {
    const raw = GALLERY_MAP[label]?.url;
    if (!raw) return;
    // Chuẩn hóa để tránh lặp `/gallery/` hoặc dư dấu `/`
    const sanitized = raw.replace(/^\/+/, '').replace(/^gallery\/+/, '');
    
    // Nếu preserveState = true, giữ nguyên state hiện tại (ví dụ: fromHotspot flag và previousUrl)
    // Điều này đảm bảo khi navigate giữa các gallery items, vẫn giữ nguyên previousUrl ban đầu
    // Kiểm tra cả history.location.state và window.history.state để đảm bảo không bị mất
    let currentState = undefined;
    if (preserveState) {
      currentState = history.location.state;
      // Nếu state từ React Router không có, thử lấy từ window.history.state
      if (!currentState && window.history?.state) {
        const windowState = window.history.state;
        if (windowState.fromHotspot || windowState.previousUrl) {
          currentState = {
            fromHotspot: windowState.fromHotspot || false,
            previousUrl: windowState.previousUrl || null,
          };
        }
      }
    }
    
    history.push({
      pathname: `/gallery/${sanitized}`,
      state: currentState,
    });
  };
};
